import {
  GeneralModalNoButtonVariant,
  GeneralModalYesButtonVariant,
} from '../components/Molecules/GeneralModal';
import { TextButtonVariant } from '../components/Molecules/TextButton';

import { Icons, IconType } from './icons';
import { Images } from './images';
import { SVGIconType } from './svgIcon';

export enum WebPageType {
  JOYAJOY = 'JOYAJOY',
  WEA = 'WEA',
}

export enum WebPageLink {
  Domain = 'domain',
  Home = 'home',
  Entry = 'entry',
  Register = 'register',
  Login = 'login',
  ForgotPassword = 'forgotPassword',
  ResetPassword = 'resetPassword',
  Account = 'account',
}

const webPageLinks: Record<WebPageLink, Record<WebPageType, string>> = {
  [WebPageLink.Domain]: {
    [WebPageType.JOYAJOY]: '',
    [WebPageType.WEA]: '/wea-member',
  },
  [WebPageLink.Home]: {
    [WebPageType.JOYAJOY]: '/',
    [WebPageType.WEA]: '/wea-member',
  },
  [WebPageLink.Entry]: {
    [WebPageType.JOYAJOY]: '/start',
    [WebPageType.WEA]: '/wea-member/start',
  },
  [WebPageLink.Register]: {
    [WebPageType.JOYAJOY]: '/register',
    [WebPageType.WEA]: '/wea-member/register',
  },
  [WebPageLink.Login]: {
    [WebPageType.JOYAJOY]: '/login',
    [WebPageType.WEA]: '/wea-member/login',
  },
  [WebPageLink.ForgotPassword]: {
    [WebPageType.JOYAJOY]: '/forgot-password',
    [WebPageType.WEA]: '/wea-member/forgot-password',
  },
  [WebPageLink.ResetPassword]: {
    [WebPageType.JOYAJOY]: '/reset-password',
    [WebPageType.WEA]: '/wea-member/reset-password',
  },
  [WebPageLink.Account]: {
    [WebPageType.JOYAJOY]: '/settings/account',
    [WebPageType.WEA]: '/wea-member/settings/account',
  },
};

type WebPageVairant = {
  logo: string;
  horizontalLogo: string;
  circleTick: SVGIconType;
  fullname: string;
  logoName: string;
  copyrightText: string;
  //
  classVariantLight1: string;
  classVariantLight2: string;
  classVariantLight3: string;
  classVariantBackground: string;
  textButtonVariant: TextButtonVariant;
  generalModalNoButtonVariant: GeneralModalNoButtonVariant;
  generalModalYesButtonVariant: GeneralModalYesButtonVariant;
};

const webPageVairant: Record<WebPageType, WebPageVairant> = {
  [WebPageType.JOYAJOY]: {
    logo: Icons[IconType.JoyajoyIcon],
    horizontalLogo: Icons[IconType.JOYAJOYHeaderLogo],
    circleTick: SVGIconType.CircleCheckboxTick,
    fullname: 'JOYAJOY',
    logoName: 'JOYAJOY',
    copyrightText: 'Copyright © 2017 - {currentYear} JOYAJOY.',
    //
    classVariantLight1: 'joyajoyLight1',
    classVariantLight2: 'joyajoyLight2',
    classVariantLight3: 'joyajoyLight3',
    classVariantBackground: 'joyajoyBackground',
    textButtonVariant: TextButtonVariant.Cyan,
    generalModalNoButtonVariant: GeneralModalNoButtonVariant.Cyan,
    generalModalYesButtonVariant: GeneralModalYesButtonVariant.Cyan,
  },
  [WebPageType.WEA]: {
    logo: Images.ForWEAProgram_img2,
    horizontalLogo: Images.WorldEducatorsA_Logo_202010_Horizontal_WEA_Eng,
    circleTick: SVGIconType.CircleTickBlue,
    fullname: 'World Educators Association (WEA)',
    logoName: 'WEA',
    copyrightText: 'Copyright © 2017 - {currentYear} WEA.',
    //
    classVariantLight1: 'weaLight1',
    classVariantLight2: 'weaLight2',
    classVariantLight3: 'weaLight3',
    classVariantBackground: 'weaBackground',
    textButtonVariant: TextButtonVariant.WEABlue,
    generalModalNoButtonVariant: GeneralModalNoButtonVariant.WEABlue,
    generalModalYesButtonVariant: GeneralModalYesButtonVariant.WEABlue,
  },
};

export const getWebPageLink = (
  webpageType: WebPageType,
  webPageLink: WebPageLink,
) => {
  return webPageLinks[webPageLink][webpageType];
};

export const getWebPageCustomLink = (
  webpageType: WebPageType,
  webPageLink: string,
) => {
  return webPageLinks[WebPageLink.Domain][webpageType] + webPageLink;
};

export const getWebPageVariant = (webpageType: WebPageType) => {
  return webPageVairant[webpageType];
};
